import React from 'react';
import PropTypes from 'prop-types';
import momentTz from 'moment-timezone';

const TimezoneSelect = ({ value, onChange, className }) => {
  const timezoneList = momentTz.tz.names();

  return (
    <select
      className={className}
      aria-label="select timezone"
      onChange={(e) => onChange(e.target.value)}
      value={value}
    >
      <option value="" disabled>-- Select a Time Zone --</option>
      {timezoneList.map((timezoneName) => (
        <option key={timezoneName} value={timezoneName}>
          {timezoneName}
        </option>
      ))}
    </select>
  );
};

TimezoneSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

TimezoneSelect.defaultProps = {
  value: '',
  className: 'form-control w-75',
};

export default TimezoneSelect;
